import { useContext } from 'react';

import { useSearchParams } from 'next/navigation';

import { isExternalPLALander } from '../helpers/isExternalPLALander';

import { RefererContext } from '@/modules/activityTracker/RefererProvider';
import {
  VARIANT_A_IDENTIFIER,
  VARIANT_B_IDENTIFIER,
  VARIANT_IDENTIFIER,
} from '@/modules/experiments/config';
import { useExperiments } from '@/modules/experiments/useExperiments';
import {
  SIMILAR_ITEMS_SASH_PRODUCTS_CONDENSED_COUNT,
  SIMILAR_ITEMS_SASH_PRODUCTS_COUNT,
} from '@/modules/similar/constants';
import { useCountryHeader } from '@/modules/user/useCountryHeader';

export function useBespokeCondensedPDP() {
  const params = useSearchParams();
  const referer = useContext(RefererContext) || null;
  const countryCode = useCountryHeader();

  const [
    { web_8744_bespoke_pla_pdp_condensed_v2, web_9153_bespoke_condensed_pdp },
  ] = useExperiments(
    ['web_8744_bespoke_pla_pdp_condensed_v2', 'web_9153_bespoke_condensed_pdp'],
    { deferred: true }
  );

  const isAUS = countryCode?.toUpperCase() === 'AU';

  const isCondensedEligible =
    isExternalPLALander({ params, referer }) &&
    !isAUS &&
    (web_8744_bespoke_pla_pdp_condensed_v2 === VARIANT_A_IDENTIFIER ||
      web_8744_bespoke_pla_pdp_condensed_v2 === VARIANT_B_IDENTIFIER);

  const isVariant =
    isCondensedEligible &&
    web_9153_bespoke_condensed_pdp === VARIANT_IDENTIFIER;

  return {
    isVariant,
    similarSashCount: isVariant
      ? SIMILAR_ITEMS_SASH_PRODUCTS_CONDENSED_COUNT
      : SIMILAR_ITEMS_SASH_PRODUCTS_COUNT,
  };
}
